import {useEffect, useState} from 'react';
import {getData} from '../services/api-handler';
import {Classes, HTMLSelect, InputGroup, Section, SectionCard, Tab, Tabs, TabsExpander, Button} from '@blueprintjs/core';

export default function EmployeeReconcile() {
     const [sikEmployeeData, setSIKEmployeeData] = useState([]);
     const [tigaEmployeeData, setTigaEmployeeData] = useState([]);
     const [tigaEmployeeName, setTigaEmployeeName] = useState('');
     const [sikEmployeeName, setSikEmployeeName] = useState('');
     const [companyDropdown, setCompanyDropdown] = useState([]);
     const [divisionDropdown, setDivisionDropdown] = useState([]);
     const [division, setDivision] = useState('');
     const [sikCompanyCode, setSIKCompanyCode] = useState('');
     const [tigaCompanyCode, setTIGACompanyCode] = useState('');
     const [activeTabId, setActiveTabId] = useState(`personal-${tigaEmployeeData[0]?.id}`);
     const [activeSIKTabId, setActiveSIKTabId] = useState(`personal-${tigaEmployeeData[0]?.id}`);
     const [sikLoading, setSIKLoading] = useState(true);
     const [tigaLoading, setTigaLoading] = useState(true);

     useEffect(() => {
          const retrieveTIGAEmployeeData = async () => {
               const retrievedEmployeeData = await getData('/tiga/employee/fetch?comp=' + tigaCompanyCode + '&div=' + division + '&page=1&size=50');
               const data = retrievedEmployeeData.data;
               const response = retrievedEmployeeData.response;
               if (response) {
                    setTigaLoading(false);
               }
               setTigaEmployeeData(data);
          };
          const retrieveSIKEmployeeData = async () => {
               const retrievedEmployeeData = await getData('/sik/employee/fetch?comp=' + sikCompanyCode + '&div=' + division + '&page=1&size=50');
               const data = retrievedEmployeeData.data;
               const response = retrievedEmployeeData.response;
               if (response) {
                    setSIKLoading(false);
               }
               setSIKEmployeeData(data);
          };

          const retrieveCompanyDropdown = async () => {
               const retrievedCompanyDropdown = await getData('/tiga/properties/company-dropdown');
               setCompanyDropdown(retrievedCompanyDropdown.data);
          };

          const retrieveDivisionDropdown = async () => {
               const retrievedCompanyDropdown = await getData('/tiga/properties/division-dropdown');
               setDivisionDropdown(retrievedCompanyDropdown.data);
          };

          if (tigaEmployeeName === '') {
               retrieveTIGAEmployeeData();
          }

          if (sikEmployeeName === '') {
               retrieveSIKEmployeeData();
          }

          retrieveCompanyDropdown();
          retrieveDivisionDropdown();
     }, [division, tigaCompanyCode, sikCompanyCode, tigaEmployeeName, sikEmployeeName]);

     useEffect(() => {
          const retrieveTigaEmployeeByName = async () => {
               const filterEmpoyeeData = await getData('/tiga/employee/filter?name=' + tigaEmployeeName);
               const filteredEmployeeData = filterEmpoyeeData.data;
               const response = filterEmpoyeeData.response;
               if (response) {
                    setTigaLoading(false);
               }

               setTigaEmployeeData(filteredEmployeeData);
          };

          const retrieveSikEmployeeByName = async () => {
               const filterSIKEmpoyeeData = await getData('/sik/employee/filter?name=' + sikEmployeeName);
               const filteredSIKEmployeeData = filterSIKEmpoyeeData.data;
               const response = filterSIKEmpoyeeData.response;
               if (response) {
                    setSIKLoading(false);
               }
               setSIKEmployeeData(filteredSIKEmployeeData);
          };

          if (sikEmployeeName !== '' && sikEmployeeName.length > 3) {
               retrieveSikEmployeeByName();
          }

          if (tigaEmployeeName !== '' && tigaEmployeeName.length > 3) {
               retrieveTigaEmployeeByName();
          }
     }, [sikEmployeeName, tigaEmployeeName]);

     const handleDivisionSelect = (e) => {
          setDivision(e.target.value);
     };

     const handleCompanySelect = (e) => {
          console.log(JSON.parse(e.target.value));
          const selectedCompany = JSON.parse(e.target.value);

          setTigaEmployeeData([]);
          setSIKEmployeeData([]);

          setTIGACompanyCode(selectedCompany.id);
          setSIKCompanyCode(selectedCompany.sikID);

          setSIKLoading(true);
          setTigaLoading(true);
     };

     const [tigaSectionStates, setTigaSectionStates] = useState(tigaEmployeeData.length > 0 ? tigaEmployeeData.map(() => false) : []);
     const [sikSectionStates, setSIKSectionStates] = useState(sikEmployeeData.length ? sikEmployeeData.map(() => false) : []);

     const handleTigaSectionClick = (index) => {
          setTigaSectionStates((prevStates) => {
               const newStates = [...prevStates];
               newStates[index] = !newStates[index];
               return newStates;
          });
     };

     const handleSIKSectionClick = (index) => {
          setSIKSectionStates((prevStates) => {
               const newStates = [...prevStates];
               newStates[index] = !newStates[index];
               return newStates;
          });
     };

     const handleTabChange = (newTabId) => {
          console.log(newTabId);
          setActiveTabId(newTabId);
     };

     const handleSIKTabChange = (newTabId) => {
          console.log(newTabId);
          setActiveSIKTabId(newTabId);
     };

     const renderSIKPersonalData = (s) => (
          <div className="metadata-panel">
               {renderInfoItem('Nama', s.fullName)}
               {renderInfoItem('Nomor KK', s.noKK ? s.noKK : '-')}
               {renderInfoItem('Nomor KTP', s.idCard ? s.idCard : '-')}
               {renderInfoItem('Kewarganegaraan', '-')}
               {renderInfoItem('Tanggal Lahir', s.birthDate ? s.birthDate : '-')}
               {renderInfoItem('Tempat Lahir', s.birthPlace ? s.birthPlace : '-')}
               {renderInfoItem('Agama', s.religionName ? s.religionName : '-')}
               {renderInfoItem('Jenis Kelamin', s.genderDesc ? s.genderDesc : '-')}
               {renderInfoItem('Alamat Sesuai KTP', s.address ? s.address : '-')}
               {renderInfoItem('Alamat Tempat Tinggal', s.currentAddress ? s.currentAddress : '-')}
               {renderInfoItem('Kode POS', s.kodepos ? s.kodepos : '-')}
               {renderInfoItem('Nomor Telepon', s.mobile ? s.mobile : '-')}
               {renderInfoItem('Nomor Telepon Rumah', s.phone ? s.phone : '-')}
               {renderInfoItem('Status Pernikahan', s.maritalDesc ? s.maritalDesc : '-')}
               {renderInfoItem('Jumlah Anak', s.child ? s.child : '-')}
               {renderInfoItem('Jumlah Tanggungan', '-')}
               {renderInfoItem('Nama Ibu', s.motherName ? s.motherName : '-')}
               {renderInfoItem('Pendidikan Terakhir', s.eduGradeDesc ? s.eduGradeDesc : '-')}
               {renderInfoItem('Gelar Akademis', '-')}
          </div>
     );

     const renderSIKOfficialData = (s) => (
          <div className="metadata-panel">
               {renderInfoItem('NIK', s.nik ? s.nik : '-')}
               {renderInfoItem('Tanggal Mulai Bekerja', s.startDate ? s.startDate : '-')}
               {renderInfoItem('Perusahaan', s.companyNameAlias ? s.companyNameAlias : '-')}
               {renderInfoItem('Divisi', s.divisionName ? s.divisionName : '-')}
               {renderInfoItem('Posisi', s.detailPosition ? s.detailPosition : '-')}
               {renderInfoItem('Status Kepegawaian', s.positionName ? s.positionName : '-')}
               {renderInfoItem('Tipe Kepegawaian', s.salaryTypeDesc ? s.salaryTypeDesc : '-')}
               {renderInfoItem('NPWP', s.npwp ? s.npwp : '-')}
               {renderInfoItem('BPJS Kesehatan', s.bpjsKesehatanAccNo ? s.bpjsKesehatanAccNo : '-')}
               {renderInfoItem('BPJS Ketenagakerjaan', s.jamsostekAcc ? s.jamsostekAcc : '-')}
               {renderInfoItem('Bank Aktif', '-')}
               {renderInfoItem('Nomor Rekening BCA', s.bankAcc ? s.bankAcc : '-')}
               {renderInfoItem('Nomor Rekening Mandiri', s.bankAcc2 ? s.bankAcc2 : '-')}
               {renderInfoItem('Nomor Rekening OCBC', s.bankAcc3 ? s.bankAcc3 : '-')}
               {renderInfoItem('Email Kantor', '-')}
               {renderInfoItem('Email Pribadi', '-')}
               {renderInfoItem('RFIDTag', s.rfidTag ? s.rfidTag : '-')}
               {renderInfoItem('Kategori Jam Kerja', s.workHour ? s.workHour : '-')}
               {renderInfoItem('Jam Kerja Harian', s.totalWorkHourPerDay ? s.totalWorkHourPerDay + ' Jam' : '-')}
               {renderInfoItem('ID Skype', s.skype ? s.skype : '-')}
          </div>
     );

     const renderTigaPersonalData = (t) => (
          <div className="metadata-panel">
               {renderInfoItem('Nama', (t.firstName + ' ' + t.lastName).toUpperCase())}
               {renderInfoItem('Nomor KK', t.familyCard ? t.familyCard : '-')}
               {renderInfoItem('Nomor KTP', t.idCard ? t.idCard : '-')}
               {renderInfoItem('Kewarganegaraan', t.country ? (t.country === 'Indonesia' ? t.country + ' (WNI)' : t.country + ' (WNA)') : '-')}
               {renderInfoItem('Tanggal Lahir', t.birthDate ? t.birthDate : '-')}
               {renderInfoItem('Tempat Lahir', t.birthPlace ? t.birthPlace : '-')}
               {renderInfoItem('Agama', t.religion ? t.religion.toUpperCase() : '-')}
               {renderInfoItem('Jenis Kelamin', t.gender ? (t.gender === 'Male' ? 'PRIA' : 'WANITA') : '-')}
               {renderInfoItem('Alamat Sesuai KTP', t.homeAddress ? t.homeAddress : '-')}
               {renderInfoItem('Alamat Tempat Tinggal', t.mainAddress ? t.mainAddress : '-')}
               {renderInfoItem('Kode POS', t.postalCode ? t.postalCode : '-')}
               {renderInfoItem('Nomor Telepon', t.cellPhone ? t.cellPhone : '-')}
               {renderInfoItem('Nomor Telepon Rumah', t.homePhone ? t.homePhone : '-')}
               {renderInfoItem('Status Pernikahan', t.maritalStatus ? t.maritalStatus : '-')}
               {renderInfoItem('Jumlah Anak', t.child ? t.child : '-')}
               {renderInfoItem('Jumlah Tanggungan', t.numberOfDependents ? t.numberOfDependents : '0')}
               {renderInfoItem('Nama Ibu', t.motherName ? t.motherName : '-')}
               {renderInfoItem('Pendidikan Terakhir', t.lastEducation ? t.lastEducation : '-')}
               {renderInfoItem('Gelar Akademis', t.academicTitle ? t.academicTitle : '-')}
          </div>
     );

     const renderTigaOfficialData = (t) => (
          <div className="metadata-panel">
               {renderInfoItem('NIK', t.employeeIDNumber ? t.employeeIDNumber : '-')}
               {renderInfoItem('Tanggal Mulai Bekerja', t.startDate ? t.startDate : '-')}
               {renderInfoItem('Perusahaan', t.companyName ? t.companyName : '-')}
               {renderInfoItem('Divisi', t.division ? t.division : '-')}
               {renderInfoItem('Posisi', t.position ? t.position : '-')}
               {renderInfoItem('Status Kepegawaian', t.positionLevel ? t.positionLevel : '-')}
               {renderInfoItem('Tipe Kepegawaian', t.salaryType ? t.salaryType : '-')}
               {renderInfoItem('NPWP', t.taxID ? t.taxID : '-')}
               {renderInfoItem('BPJS Kesehatan', t.bpjsKes ? t.bpjsKes : '-')}
               {renderInfoItem('BPJS Ketenagakerjaan', t.bpjsKet ? t.bpjsKet : '-')}
               {renderInfoItem('Bank Aktif', t.activeBankAccount ? t.activeBankAccount : '-')}
               {renderInfoItem('Nomor Rekening BCA', t.bcaNumber ? t.bcaNumber : '-')}
               {renderInfoItem('Nomor Rekening Mandiri', t.mandiriNumber ? t.mandiriNumber : '-')}
               {renderInfoItem('Nomor Rekening OCBC', t.ocbcnumber ? t.ocbcnumber : '-')}
               {renderInfoItem('Email Kantor', t.email ? t.email : '-')}
               {renderInfoItem('Email Pribadi', t.personalEmail ? t.personalEmail : '-')}
               {renderInfoItem('RFIDTag', t.rfidTag ? t.rfidTag : '-')}
               {renderInfoItem('Kategori Jam Kerja', t.workHour ? t.workHour : '-')}
               {renderInfoItem('Jam Kerja Harian', t.totalWorkHour ? t.totalWorkHour + ' Jam' : '-')}
               {renderInfoItem('ID Skype', t.skype ? t.skype : '-')}
          </div>
     );

     const renderInfoItem = (label, value) => (
          <div>
               <span className={Classes.TEXT_MUTED}>{label}</span>
               <div style={{float: 'right'}}>{value}</div>
               <hr style={{margin: '1px'}} />
          </div>
     );

     return (
          <div className="content-wrapper">
               <div className="prop-container">
                    <div className="prop">
                         <HTMLSelect name="office" onChange={handleCompanySelect}>
                              <option value="all">Semua Office</option>
                              {companyDropdown.map((c, i) => (
                                   <option key={i} value={JSON.stringify({sikID: c.sikid, id: c.id})}>
                                        {c.companyName}
                                   </option>
                              ))}
                         </HTMLSelect>
                    </div>
                    <div className="prop">
                         <HTMLSelect name="division" onChange={handleDivisionSelect}>
                              <option value="all">Semua Divisi</option>
                              {divisionDropdown.map((d, i) => (
                                   <option key={i} value={d.divisionName}>
                                        {d.divisionName}
                                   </option>
                              ))}
                         </HTMLSelect>
                    </div>
               </div>
               <div className="col-container">
                    <div className="col">
                         <p>
                              <strong>Data Karyawan TIGA</strong>
                         </p>
                         <InputGroup
                              className="space-bottom"
                              name="tiga-employee"
                              type="text"
                              placeholder="Cari data karyawan TIGA  berdasarkan nama..."
                              onChange={(e) => {
                                   setTigaEmployeeName(e.target.value);
                                   setTigaEmployeeData([]);
                                   setTigaLoading(true);
                              }}
                         />
                         <div className="list-container">
                              {tigaEmployeeData.length > 0 ? (
                                   tigaEmployeeData.map((t, i) => (
                                        <Section key={i} onClick={handleTigaSectionClick} collapsible collapseProps={{isOpen: tigaSectionStates[i], defaultIsOpen: false, transitionDuration: 0}} compact title={(' [ ' + (i + 1) + ' ] ' + t.firstName + ' ' + t.lastName).toUpperCase()} subtitle={t.companyName + ' - ' + t.division}>
                                             <SectionCard padded className={Classes.CARD_LIST_BORDERED}>
                                                  <Tabs animate selectedTabId={activeTabId} onChange={handleTabChange}>
                                                       <Tab id={`personal-${t.id}`} title="Data Pribadi" panel={renderTigaPersonalData(t)} />
                                                       <Tab id={`official-${t.id}`} title="Data Kepegawaian" panel={renderTigaOfficialData(t)} />
                                                       <a className="links" href={'https://fusa.formulatrix.com/tigacrm/#/HRIS/Employee?v=1&fEmployee=S%23ID%20is%20' + t.id} target="_blank" rel="noreferrer">
                                                            <Button small className="bp5-minimal" icon="link">
                                                                 Link
                                                            </Button>
                                                       </a>
                                                       <TabsExpander />
                                                  </Tabs>
                                             </SectionCard>
                                        </Section>
                                   ))
                              ) : (
                                   <NoData isLoading={tigaLoading} />
                              )}
                         </div>
                    </div>
                    <div className="col">
                         <p>
                              <strong>Data Karyawan SIK</strong>
                         </p>
                         <InputGroup
                              className="space-bottom"
                              name="sik-employee"
                              type="text"
                              placeholder="Cari data karyawan SIK berdasarkan nama..."
                              onChange={(e) => {
                                   setSikEmployeeName(e.target.value);
                                   setSIKEmployeeData([]);
                                   setSIKLoading(true);
                              }}
                         />
                         <div className="list-container">
                              {sikEmployeeData.length > 0 ? (
                                   sikEmployeeData.map((s, i) => (
                                        <Section key={i} onClick={handleSIKSectionClick} collapsible collapseProps={{isOpen: sikSectionStates[i], defaultIsOpen: false, transitionDuration: 0}} compact title={' [ ' + (i + 1) + ' ] ' + s.fullName} subtitle={s.companyNameAlias + ' - ' + s.divisionName}>
                                             <SectionCard padded className={Classes.CARD_LIST_BORDERED}>
                                                  <Tabs animate selectedTabId={activeSIKTabId} onChange={handleSIKTabChange}>
                                                       <Tab id={`personal-${s.id}`} title="Data Pribadi" panel={renderSIKPersonalData(s)} />
                                                       <Tab id={`official-${s.id}`} title="Data Kepegawaian" panel={renderSIKOfficialData(s)} />
                                                       <a className="links" href={'https://sik.formulatrix.com/home.php?page=19&&pg=1&&uid=' + s.nik} target="_blank" rel="noreferrer">
                                                            <Button small className="bp5-minimal" icon="link">
                                                                 Link
                                                            </Button>
                                                       </a>
                                                       <TabsExpander />
                                                  </Tabs>
                                             </SectionCard>
                                        </Section>
                                   ))
                              ) : (
                                   <NoData isLoading={sikLoading} />
                              )}
                         </div>
                    </div>
               </div>
          </div>
     );

     function NoData({isLoading}) {
          return <div className="no-data">{isLoading ? 'Memuat...' : 'Tidak Ada Data'}</div>;
     }
}
